import React from 'react';
import { Link } from 'react-router-dom';

// styles imports
import '../css/projectCard.css';

function ProjectCard({ project }) {
  const isPublic = project.public !== false; // Asume true si no está especificado

  const cardContent = (
    <>
      <div className="project_card_image">
        <img
          className="project_card_cover"
          src={project.cover}
          alt={project.title}
        />

        {project["cover-alt"] && (
          <img
            className="project_card_cover project_card_cover--hover"
            src={project["cover-alt"]}
            alt=""
            aria-hidden="true"
          />
        )}
      </div>

      <p>
        {project.description}
        {!isPublic && ( <span className='project_card_badge'>/ Próximamente</span> )}
      </p>
    </>
  );

  if (!isPublic) {
    return (
      <div className="project_card project_card--disabled" aria-disabled="true">
        {cardContent}
      </div>
    );
  }

  return (
    <Link
      to={`/proyecto/${project.ID}`}
      className="project_card"
    >
      {cardContent}
    </Link>
  );
}

export default ProjectCard;